import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import Menu from "../components/menu"
import Navbar from "../components/navbar"
import TitleH1 from "../components/titleH1"
// REDUX
import {bindActionCreators} from "redux"
import allTheActions from "../actions"
import {connect} from "react-redux"
//
import Table from "../components/table"
import DivWhite from "../components/divWhite"
import CheckBox from "../components/checkbox"
import TextAlign from "../components/textAlign"
import Button from "../components/button"
import TitleH3 from "../components/titleH3"
import Popup from "../components/popupSwal"

const Waiting = props => {
    const [data, setData] = useState([])
    const [licencesGroup, setLicencesGroup] = useState([])
    const [clubs, setClubs] = useState([])
    const [checked, setChecked] = useState([])
    const history = useHistory()

    useEffect(() => {
        const fetchLicences = async () => {
            setData(await props.actions.licence.getLicencesWaiting())
        }
        fetchLicences()
    }, [props.actions.licence])

    useEffect(() => {
        const fetchClubs = async () => {
            const res = await props.actions.club.getAllClubs()
            await setClubs(res.clubs)
        }
        fetchClubs()
    }, [props.actions.club])

    useEffect(() => {
        const getLicences = async () => {
            //On tri par clubs
            const objet = Object.entries(data.reduce((res, curr) => {
                if (res[curr.idClub]) res[curr.idClub].push(curr)
                else Object.assign(res, {[curr.idClub]: [curr]})
                return res
            }, {}))
            await setLicencesGroup(await objet)
        }
        getLicences()
    }, [data])

    const countChecked = async () => {
        const checkboxes = document.getElementsByTagName('input')
        for (let i = 1; i < checkboxes.length; i++) if (checkboxes[i].checked) return 1
        return 0
    }

    const checkAllClub = async event => {
        const checkboxes = document.querySelectorAll(`input`)
        let checkTemp = []

        if (event.target.checked) {
            for (let i = 1; i < checkboxes.length; i++) {
                checkTemp.push(checkboxes[i].name)
                checkboxes[i].checked = true
            }
            setChecked(await checkTemp)
        } else {
            for (let i = 1; i < checkboxes.length; i++) checkboxes[i].checked = false
            setChecked(await [])
        }
    }

    const handleCheck = async event => {
        if (event.target.checked) setChecked(await [...checked, event.target.name])
        else setChecked(await checked.filter(licence => licence !== event.target.name))

        if (await countChecked() === 0) document.getElementById("check").checked = false
    }

    const licencesValid = async (arrayLicences) => {
        const filtered = []
        arrayLicences.forEach(id => filtered.push(id._id))

        if (await props.actions.licence.updateLicencesValid(filtered))
            Popup("Validation réussie", "Les licences ont été validées", async () => {
                let newArray = []
                data.forEach(uneData => {
                    if (!filtered.includes(uneData._id)) newArray.push(uneData)
                })
                await setData(newArray)
                history.push('/dashboard')
            })
        else alert("Une erreur est survenue, veuillez contacter un administrateur")
    }


    return (
        <>
            <Navbar/>
            <Menu/>
            <TitleH1 content="Les licences en attente de validation"/>
            {licencesGroup.length <= 0 ? <TitleH3 content="Il n'y a aucune licence en attente de validation."/>
                : <TextAlign content={
                    <CheckBox id="check" name="check" onChange={(e) => checkAllClub(e)}/>
                } align="right"/>}

            <DivWhite content={
                licencesGroup.length > 0 && clubs.length > 0 ?
                    licencesGroup.map(licence => {
                        //licence[0] = idClub
                        //licence[1] = les licences du club
                        //On chope uniquement le club qui nous intéresse
                        const club = clubs.filter(data => data._id === licence[0])
                        return (
                            <Table id={`table${licence[0]}`} key={licence[0]} content={
                                <>
                                    <thead>
                                    <tr>
                                        <td colSpan="5">
                                            {
                                                club.length > 0 ? club[0].nom
                                                    : <span>Licence individuelle</span>
                                            }
                                        </td>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {
                                        licence[1].map(licence => {
                                            return <tr key={licence._id}>
                                                <td>{licence.prenom}</td>
                                                <td>{licence.nom}</td>
                                                <td>{licence.numeroLicence}</td>
                                                <td>{licence.categorie}</td>
                                                <td><CheckBox name={licence._id}
                                                              onChange={(e) => handleCheck(e)}/></td>
                                            </tr>
                                        })
                                    }
                                    </tbody>
                                </>
                            } width="100%"/>

                        )
                    })
                    : null
            } width="100%"/>

            {checked.length > 0 ?
                <Button value={`Valider ${checked.length} licence(s)`} onClick={() => {
                    const arrayLicences = data.filter(licence => checked.includes(licence._id))
                    if (window.confirm(`Vous êtes sur le point de valider ${checked.length} licence(s). Continuer ?`))
                        licencesValid(arrayLicences)
                }}/>
                : null}

        </>
    )
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Waiting)
